import React from 'react';
import { Text, Icon, Flex } from '@qga/roo-ui/components';
import type { Offer } from 'types/property';
import { shouldShowAvailableRoomsMessage } from 'lib/utils/shouldShowAvailableRoomsMessage';
import { getRoomAvailabilityMessageStandard, getRoomAvailabilityMessageForOffer } from './getRoomAvailabilityMessage';

type CombinedAvailabilityMessageProps = Required<Pick<Offer, 'allocationsAvailable'>> & {
  mt?: number;
  isOffer?: boolean;
};

const RoomsAvailabilityMessage = ({ allocationsAvailable, mt = 0, isOffer = false }: CombinedAvailabilityMessageProps) => {
  const showRoomsAvailabilityMessage = shouldShowAvailableRoomsMessage(allocationsAvailable);

  if (!showRoomsAvailabilityMessage) {
    return null;
  }

  const message = isOffer
    ? getRoomAvailabilityMessageForOffer(allocationsAvailable)
    : getRoomAvailabilityMessageStandard(allocationsAvailable);

  return (
    <Flex color="brand.primary" alignItems="center" gap="1" mt={mt} data-testid="rooms-availability-message">
      <Icon name="errorOutline" size={16} />
      <Text fontWeight="bold">{message}</Text>
    </Flex>
  );
};

export default RoomsAvailabilityMessage;
